/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { accessAPI, downloadFile, useEstetica } from "../../shared";
import { Boton } from "../../shared";
import { Card } from "primereact/card";
import logoVerticalBlanco from "../../images/logoVerticalBlanco.png";

export default function DocumentosPublicos() {
  const estetica = useEstetica();
  // Si la estética no cargó, el texto sigue leyéndose sin el nombre propio.
  const nombreOrganismo = estetica?.nombre || "el organismo";
  const [documentos, setDocumentos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [descargandoId, setDescargandoId] = useState(null);

  useEffect(() => {
    accessAPI(
      "GET",
      "documento",
      null,
      (respuesta) => {
        setDocumentos(respuesta);
        setCargando(false);
      },
      () => {
        setCargando(false);
      }
    );
  }, []);

  function descargarDocumento(doc) {
    if (doc.externo) {
      window.open(doc.linkExterno, "_blank");
      return;
    }
    const version = doc.documentoVersions[0];
    setDescargandoId(doc.id);
    // Si la versión tiene PDF generado, priorizarlo sobre el editable
    const archivoIdDescarga = version.archivoPDFId || version.archivoId;
    const nombreDescarga = version.archivoPDFId
      ? version.archivoPDF?.nombredescarga
      : version.archivo.nombredescarga;
    downloadFile(
      `documento/archivo/${archivoIdDescarga}`,
      nombreDescarga,
      () => setDescargandoId(null),
      () => setDescargandoId(null)
    );
  }

  return (
    <main
      css={{
        paddingBottom: "50px",
        minHeight: "calc(100vh - var(--alturaFooter))",
        padding: "0px 10px"
      }}
    >
      <div
        css={{
          paddingTop: "50px",
          marginBottom: "30px",
          width: "100%",
          marginLeft: "auto",
          marginRight: "auto"
        }}
      >
        <img
          css={{
            width: "150px",
            marginLeft: "auto",
            marginRight: "auto",
            display: "block"
          }}
          // El logo en blanco del organismo; si no cargó uno, el de la
          // plataforma.
          src={estetica?.logos?.blanco || logoVerticalBlanco}
          alt="logo"
        />
      </div>

      <div css={{ paddingBottom: "50px" }}>
        <Card
          css={{
            maxWidth: "800px",
            marginLeft: "auto",
            marginRight: "auto"
          }}
        >
          <h1 css={{ textAlign: "center", marginBottom: "0.5em" }}>
            Reglamentos y documentos de interés
          </h1>
          <p>
            Aquí podrá descargar documentos que pueden ser de interés para sus
            actividades con el {nombreOrganismo}.
          </p>
          <p>
            La firma de servicios con {nombreOrganismo} puede implicar el
            conocimiento y aceptación de las condiciones dentro de estos
            documentos.
          </p>

          {cargando && (
            <div
              css={{
                display: "flex",
                justifyContent: "center",
                marginTop: "2em"
              }}
            >
              <i className="pi pi-spin pi-spinner" css={{ fontSize: "2em" }} />
            </div>
          )}

          {!cargando && documentos.length > 0 && (
            <div
              css={{
                marginTop: "1.5em",
                display: "flex",
                flexDirection: "column",
                gap: "0.5em"
              }}
            >
              {documentos.map((doc) => {
                const version = doc.documentoVersions[0];
                const descargando = descargandoId === doc.id;
                return (
                  <div
                    key={doc.id}
                    css={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "0.75em 1em",
                      borderRadius: "8px",
                      border: "1px solid #e0e0e0"
                    }}
                  >
                    <span css={{ fontSize: "0.95em" }}>
                      {doc.codigo} - {doc.nombre}
                      {!doc.externo && version && (
                        <span css={{ color: "#888" }}>
                          {" "}
                          - v.{version.version}
                        </span>
                      )}
                    </span>
                    <Boton
                      icono
                      callback={() => descargarDocumento(doc)}
                      loader={descargando}
                      disabled={descargando}
                    >
                      <i
                        className={
                          doc.externo ? "pi pi-external-link" : "pi pi-download"
                        }
                      />
                    </Boton>
                  </div>
                );
              })}
            </div>
          )}

          {!cargando && documentos.length === 0 && (
            <p css={{ color: "gray", textAlign: "center", marginTop: "2em" }}>
              No hay documentos disponibles
            </p>
          )}
        </Card>
      </div>
    </main>
  );
}
